"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.root = exports.portalRoot = void 0;
var root = exports.root = document.getElementById('root');
var portalRoot = exports.portalRoot = document.getElementById('portal-root');